<div [ngStyle]="{height:heightloader+'%',width:width+'%'}" *ngIf="isLoading" class="loading">
    <!-- <img [src]="loader" style = "width:100%;height:100%; " /> -->
    <!-- <mat-spinner class="spinner"></mat-spinner> -->
</div>
<img [src]=image [ngStyle]="{visibility:isLoading?'hidden':'',height:height+'%',width:width+'%'}" (load)="hideLoader()" (error)="hideLoader()" media-simple="true" />
